import React from 'react';
import {Button, withStyles} from 'material-ui';
import Dropzone from 'react-dropzone';
import grey from 'material-ui/colors/grey';
import AddIcon from 'material-ui-icons/Description';
import RedirectsBulkDocument from '../../containers/redirects/forms/RedirectsBulkDocument';

const styles = theme => ({
    chip: {
        margin: '0 10px 20px 0',
    },
    svgIcon: {
        color: grey[800],
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    buttonIconSmall: {
        width: 25,
        height: 25,
        marginLeft: 5
    },
    documentIcon: {
        width: 25, 
        height: 25, 
        color: '#000'
    },
    uploadedDocError: {
        fontWeight: '700',
        color: '#ff3044'
    },
});

class DropzoneDocumentField extends React.Component {

    constructor() {
        super();
        this.state = {
            dropzoneActive: false,
            uploadedDocError: '',
        };
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
    }

    onDragEnter() {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave() {
        this.setState({
            dropzoneActive: false
        });
    }

    render() {

        const {dropzoneActive, uploadedDocError} = this.state;

        const {document, onDocumentDelete, onDocumentDrop, classes} = this.props;

        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '2.5em 0',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            color: '#9dffe2'
        };
        
        const acceptedFileType = 'text/csv';
        const acceptedFileExt = '.csv';

        let dropzoneRef;

        return (
            <div>
                <Dropzone
                    disableClick
                    multiple={false}
                    style={{position: "relative"}}
                    onDrop={(documents) => {
                        const uploadedDoc = documents[0];
                        
                        const fileType = uploadedDoc.type;
                        const fileName = uploadedDoc.name;
                        const fileExtMaybe = fileName.substring(fileName.length - acceptedFileExt.length);
    
                        /**
                         * Due to under lying bug within Windows and macOs, we can't reliable depend on upload files
                         * mime type, therefore in a slightly hacked way we
                         * check either against mime type or check the file extension
                         *
                         * CSV files are reported as text/plain under macOS but as application/vnd.ms-excel under
                         * Windows. In some cases there might not be a mime type set at all.
                         * See: https://github.com/react-dropzone/react-dropzone/issues/276
                         */
                        if (fileType === acceptedFileType || fileExtMaybe === acceptedFileExt) {
                            onDocumentDrop(uploadedDoc);
                            this.setState({
                                dropzoneActive: false,
                                uploadedDocError: ''
                            });
                        } else {
                            this.setState({
                                uploadedDocError: 'The uploaded file MUST be a csv file!'
                            });
                        }
                    }}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    ref={(node) => {dropzoneRef = node; }}
                >
                    {dropzoneActive && <div style={overlayStyle}>Drop document(s)...</div>}

                    <div>
                        <h3>Upload .CSV File</h3>
                        <h4>Drop file here or click the button to select the .csv file from your computer</h4>
                        {uploadedDocError && <h4 className={classes.uploadedDocError}>{uploadedDocError}</h4>}
                        <div className={classes.row}>
                            <RedirectsBulkDocument
                                document={document}
                                onDocumentDelete={onDocumentDelete}
                                classes={classes}
                            />
                        </div>
                    </div>
                </Dropzone>
                <Button size="small" color="default" variant="raised" onClick={() => {dropzoneRef.open() }} className={classes.buttonAdd}>
                    Open .CSV file
                    <AddIcon className={classes.buttonIconSmall}/>
                </Button>
            </div>
        )
    }
}

export default withStyles(styles)(DropzoneDocumentField);


// WEBPACK FOOTER //
// ./src/components/fields/field_dropzone_document_csv.js